import {connect} from 'react-redux';
import {formValueSelector} from 'redux-form';
import EntryDetailRefundModal from './EntryDetailRefundModal.jsx';
import {
  handleEntryDetailRefundCancelClick,
  handleEntryDetailRefundSubmitClick } from './actions';

const selector = formValueSelector('adminEntryRefundForm');

const mapStateToProps = state => ({
  visible: state.admin.entryDetail.showEntryDetailRefundModal,
  paymentType: selector(state,'paymentType'),
  refundType: state.admin.entryDetail.refundType,
  purchaseTransactions: state.admin.entryDetail.creditPurchaseTransactions ? state.admin.entryDetail.creditPurchaseTransactions : []
});

const mapDispatchToProps = dispatch => ({
  onCancelClick: () => dispatch(handleEntryDetailRefundCancelClick()),
  onSubmit: data => dispatch(handleEntryDetailRefundSubmitClick(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(EntryDetailRefundModal);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryDetailRefundModalContainer.jsx